import { DownloadableItem } from '@/features/DownloadableItem';
import { Typography } from '@/shared/ui/Typography';
import { FormattedMessage } from 'react-intl';
import type { DownloadableItemProps } from '@/features/DownloadableItem/types.ts';

interface Props {
  data: DownloadableItemProps[];
}

export const Documents = ({ data }: Props) => {
  return (
    <div className="flex-col-gap-3 xl:w-[490px]">
      <Typography as="h3" type="h3">
        <FormattedMessage defaultMessage="Документы" />
      </Typography>
      <ul>
        {data.map((item, index) => (
          <li key={item.link}>
            {index !== 0 && <div className="bg-stroke-gray h-px" />}
            <DownloadableItem {...item} />
          </li>
        ))}
      </ul>
    </div>
  );
};
